// extracted by mini-css-extract-plugin
export default {"form":"login_form__drK5D","register":"login_register__NlD9V","resetPassword":"login_resetPassword__746iH","mobileLogo":"login_mobileLogo__5AETn"};